import {XCircleFillIcon} from '@primer/octicons-react'
import {Flash, Link} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'
import {UnsafeHTMLText} from '@github-ui/safe-html/UnsafeHTML'

import styles from './FlashError.module.css'
import {clsx} from 'clsx'

export function FlashError({
  prefix,
  errorMessageUsingPrefix,
  errorMessageNotUsingPrefix,
  hideRuleErrorsTitle,
  ruleErrors,
  helpUrl,
  flashRef,
}: {
  prefix: string
  errorMessageUsingPrefix?: string
  errorMessageNotUsingPrefix?: string
  hideRuleErrorsTitle?: boolean
  ruleErrors?: string[]
  helpUrl?: string
  flashRef?: React.RefObject<HTMLDivElement>
}) {
  const isRuleViolation = (ruleErrors?.length || 0) > 0

  return errorMessageUsingPrefix || errorMessageNotUsingPrefix ? (
    <>
      <Flash
        id="flash"
        variant="danger"
        className={clsx('d-flex flex-items-center flex-justify-between', styles.Flash)}
        tabIndex={-1}
        ref={flashRef}
      >
        {errorMessageUsingPrefix ? (
          <div>
            {prefix} <UnsafeHTMLText className={styles.SafeHTMLText} html={errorMessageUsingPrefix} />
            {isRuleViolation && helpUrl && (
              <Link
                href={`${helpUrl}/repositories/configuring-branches-and-merges-in-your-repository/managing-rulesets/about-rulesets`}
                className={styles.Link}
              >
                Learn more about rulesets.
              </Link>
            )}
          </div>
        ) : (
          errorMessageNotUsingPrefix && <div>{errorMessageNotUsingPrefix}</div>
        )}
      </Flash>
      {isRuleViolation && (
        <div className={styles.Flash}>
          {!hideRuleErrorsTitle && <div className={styles.ruleViolationsTitle}>Repository rule violations found:</div>}
          {ruleErrors?.map(rule => (
            <div key={rule} className={styles.ruleViolationRow}>
              <Octicon icon={XCircleFillIcon} size={16} className={styles.Octicon} />
              <div className={styles.ruleViolationText}>{rule}</div>
            </div>
          ))}
        </div>
      )}
    </>
  ) : null
}

try{ FlashError.displayName ||= 'FlashError' } catch {}